export default __webpack_public_path__ + "media/images/images/carousel/03-3d93729ccf114263355668c6411624b5.jpg";